//* node modules
import { useState } from "react";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { Link, useLocation } from "react-router-dom";

//* Style
import "./index.scss";

import MenuButton from "../../assets/images/icon-outlined-application-menu.png";
import logo from "../../assets/images/CP-Logo.png";
import closeBtn from "../../assets/images/icon-outlined-suggested-close-square.png";
import plusRed from "../../assets/images/+.png";

const Header = () => {
  const [toggle, setToggle] = useState(false);
  let link = useLocation();
  const [active, setActive] = useState();

  const OpenMenu = () => {
    setToggle(true);
    document.body.style.overflowY = "hidden";
  };
  const CloseMenu = () => {
    setToggle(false);
    document.body.style.overflowY = "auto";
  };

  const Desktop = () => {
    return (
      <Nav className="d-flex align-items-center">
        <NavItem>
          <a href="/#about-career-plus">About Career Plus</a>
        </NavItem>
        +
        <NavItem>
          <a href="/#who-can-apply">Who Can Apply?</a>
        </NavItem>
        +
        <NavItem>
          <a href="/#process">Process</a>
        </NavItem>
        +
        <NavItem>
          <a href="/#participants">Participants</a>
        </NavItem>
        +
        <NavItem>
          <a href="/#faq">FAQ</a>
        </NavItem>
        +
        <NavItem>
          <Link
            className={link.pathname === "/contact" ? "active" : ""}
            to="/contact"
          >
            Contact Us
          </Link>
        </NavItem>
        <NavItem className="apply-now-btn d-flex align-items-center justify-content-center">
          <Link to="/application">APPLY NOW</Link>
        </NavItem>
      </Nav>
    );
  };

  const MobileMenuIcon = () => {
    return (
      <>
        <div
          onClick={() => {
            OpenMenu();
          }}
          style={{ padding: "10px" }}
        >
          <img src={MenuButton} alt="menu-button" width="24px" height="24px" />
        </div>
      </>
    );
  };

  const MobileMenu = () => {
    return (
      <div className="mobile-menu ">
        <ListGroup>
          <ListGroupItem>
            <a onClick={CloseMenu} href="/#about-career-plus">
              ABOUT <br /> CAREER PLUS
            </a>
          </ListGroupItem>
          <ListGroupItem>
            <a onClick={CloseMenu} href="/#who-can-apply">
              WHO <br />
              CAN APPLY?
            </a>
          </ListGroupItem>
          <ListGroupItem>
            <a onClick={CloseMenu} href="/#process">
              PROCESS
            </a>
          </ListGroupItem>
          <ListGroupItem>
            <a onClick={CloseMenu} href="/#participants">
              partıcıpants
            </a>
          </ListGroupItem>
          <ListGroupItem>
            <a onClick={CloseMenu} href="/#faq">
              FAQ
            </a>
          </ListGroupItem>
          <ListGroupItem>
            <Link
              onClick={CloseMenu}
              className={link.pathname === "/contact" ? "active" : ""}
              to="/contact"
            >
              CONTACT US
            </Link>
          </ListGroupItem>
          <ListGroupItem>
            <Link
              onClick={CloseMenu}
              className={link.pathname === "/application" ? "active" : ""}
              to="/application"
            >
              APPLY NOW
            </Link>
          </ListGroupItem>
        </ListGroup>

        <img
          onClick={CloseMenu}
          className="close-btn"
          src={closeBtn}
          alt="close-menu"
        />
        <img className="plus" src={plusRed} alt="plus-red" />
      </div>
    );
  };

  return (
    <div className="header">
      <Navbar className="container">
        <Link
          to="/"
          onClick={() => {
            window.scrollTo(0, 0);
          }}
        >
          <img src={logo} width="188" alt="CP-Logo" />
        </Link>
        {window.innerWidth < 991 ? MobileMenuIcon() : Desktop()}
        {toggle ? MobileMenu() : ""}
      </Navbar>
    </div>
  );
};

export default Header;
